/* Caucasus - "Lire la suite" sur les descriptions produit */
(function () {
  'use strict';

  var MORE = 'Lire la suite';
  var LESS = 'Réduire';

  function build(box) {
    var c = box.querySelector('.cs-rm__c');
    if (!c) return;
    if (box.classList.contains('is-ready') && box.querySelector('.cs-rm__btn')) return;

    var old = box.querySelector('.cs-rm__btn');
    if (old) old.remove();
    box.classList.remove('is-open');
    box.classList.add('is-ready');

    if (c.scrollHeight <= c.clientHeight + 4) {
      box.classList.remove('is-ready');
      return;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cs-rm__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="cs-rm__lbl">' + MORE + '</span><span class="cs-rm__chev" aria-hidden="true"></span>';
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.querySelector('.cs-rm__lbl').textContent = open ? LESS : MORE;
    });
    box.appendChild(btn);
  }

  function init() {
    var boxes = document.querySelectorAll('.cs-rm');
    for (var i = 0; i < boxes.length; i++) build(boxes[i]);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; init(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();